import { upperFirst } from 'lodash';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Control, Controller, UseFormWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { IMissingInformation } from '../../../pages/ListingDetail/ListingDetail.types';
import TextInput from '../../___design/TextInput';
import { StyledListingCadastralDateBody } from './ListingCadastralDataForm.styles';
import { IListingCadastralDateForm } from './ListingCadastralDataForm.types';
import { filterRequiredFieldForCadastralInformation } from './utils/filterRequiredFieldForCadestralInformation';

const ListingCadastralDateForm = ({
  control,
  watch,
  setMissingCadastralInformation,
}: {
  control: Control<IListingCadastralDateForm>;
  watch: UseFormWatch<IListingCadastralDateForm>;
  setMissingCadastralInformation: Dispatch<
    SetStateAction<IMissingInformation | null>
  >;
}) => {
  const { t } = useTranslation(['listingDetail']);
  const values = watch();

  useEffect(() => {
    const missingValue = filterRequiredFieldForCadastralInformation({ values });
    if (missingValue.fields.length === 0) {
      setMissingCadastralInformation(null);
      return;
    }
    setMissingCadastralInformation(missingValue);
  }, [JSON.stringify(values)]);

  return (
    <StyledListingCadastralDateBody>
      <Controller
        control={control}
        name="cadastral_sheet"
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="cadastral_sheet"
            name="cadastral_sheet"
            label={upperFirst(t('listingDetail:foglio'))}
            value={value ?? ''}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="cadastral_parcel"
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="cadastral_parcel"
            name="cadastral_parcel"
            label={upperFirst(t('listingDetail:particella'))}
            value={value ?? ''}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="cadastral_subordinate"
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="cadastral_subordinate"
            name="cadastral_subordinate"
            label={upperFirst(t('listingDetail:subalterno'))}
            value={value ?? ''}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="cadastral_category"
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="cadastral_category"
            name="cadastral_category"
            label={upperFirst(t('listingDetail:cadastralCategory'))}
            value={value ?? ''}
            onChange={onChange}
          />
        )}
      />
      <Controller
        control={control}
        name="cadastral_income"
        render={({ field: { onChange, value } }) => (
          <TextInput
            id="cadastral_income"
            name="cadastral_income"
            label={upperFirst(t('listingDetail:cadastralIncome'))}
            value={value ?? ''}
            onChange={onChange}
            type="number"
          />
        )}
      />
    </StyledListingCadastralDateBody>
  );
};

export default ListingCadastralDateForm;
